




















































import { Vue, Component } from 'vue-property-decorator';
import { WechatLogin, isWeiXin } from '@/common/ts/common';
import { Dialog } from 'vant';
import { share, userInfo, get4SList } from '../api';

Vue.use(Dialog);
@Component
export default class SuccessSubmit extends Vue {
  downLoadUrl =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  submitInfo: any = '';
  dataList: any = [];
  shopInfo = {};
  created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    share(this);
    this.init();
  }

  async init() {
    const res: any = await userInfo(this._getWxId());
    if (res.code === 200) {
      this.submitInfo = res.data;
    }
    const data = await get4SList();
    this.dataList = data.data;
    const [temp] = this.dataList.filter(
      (item: any) => item.id === this.submitInfo.shop_id,
    );
    this.shopInfo = temp;
    console.log('4s店信息', temp);
  }

  toApply() {
    if (!window.udid && !isWeiXin()) {
      this._downloadApp();
      return;
    }
    // 在app的时候
    if (window.gettoken() && window.gettoken() !== 'null') {
      this.$router.push({
        path: 'apply',
      });
    } else if (isWeiXin()) {
      // 在微信的时候
      if (!window.localStorage.getItem('unionid')) {
        this.$dialog
          .confirm({
            title: '微信登录',
            message: '微信参与活动需要微信登录',
          })
          .then(() => {
            console.log('确定');
            WechatLogin();
          })
          .catch(() => {
            console.log('取消');
          });
      } else {
        this.$router.push({
          path: 'apply',
        });
      }
      console.log('在微信');
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }

    return;
  }
  _downloadApp() {
    Dialog.confirm({
      title: '友情提示',
      message: '请在上游新闻App参与活动',
      confirmButtonText: '还没装？一步安装',
      cancelButtonText: '我已安装过',
      closeOnClickOverlay: true,
    })
      .then(() => {
        window.location.href = this.downLoadUrl;
      })
      .catch(() => {
        window.location.href =
          'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
      });
  }
  _getWxId() {
    let id = '';
    const wxid = window.localStorage.getItem('unionid');
    if (isWeiXin() && wxid) {
      id = wxid as string;
    }
    return id;
  }
}
